<template>
  <b-form id="campaign-info-lucky" @submit.prevent="onSubmitForm">
    <b-row>
      <b-col cols="12">
        <b-card no-body class="mb-1 pb-4 container-card">
          <div class="row px-5">
            <div class="col-12">
              <div class="row">
                <div class="col-md-12 border-b">
                  <div class="row pl-1 mt-3 justify-content-between">
                    <div class="font-medium-5 font-weight-bolder text-black">
                      {{ isEdit ? "Edit Campaign" : "Create Campaign" }}
                    </div>
                    <div>
                      <save-button
                        type="submit"
                        class="ml-1"
                        :disabled="checkInput"
                      />
                    </div>
                  </div>
                  <div
                    class="row pl-1 mt-1 font-medium-5 font-weight-bolder text-black"
                  >
                    Campaign Information
                  </div>
                  <div class="row">
                    <div class="col-md-9 mt-2">
                      <div class="row">
                        <div class="col-12 col-md-6">
                          <div class="d-flex">
                            <span class="status-toggle font-medium-5"
                              >{{ "Status" }}
                            </span>
                            <b-form-checkbox
                              fieldValue="true"
                              class="custom-control-success ml-4"
                              name="check-button"
                              switch
                              v-model="formData.status"
                            >
                            </b-form-checkbox>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-md-6">
                          <b-form-group
                            :label="'Campaign Name (Thai)'"
                            label-for="campagin-name"
                            label-class="font-medium-5 required"
                          >
                            <b-form-input
                              id="campaign-name"
                              v-model="formData.campaignNameTh"
                              placeholder="ระบุ"
                              required
                            />
                          </b-form-group>
                        </div>
                        <div class="col-12 col-md-6">
                          <b-form-group
                            :label="'Campaign Name (English)'"
                            label-for="campagin-name"
                            label-class="font-medium-5"
                          >
                            <b-form-input
                              id="campaign-name"
                              v-model="formData.campaignNameEn"
                              placeholder="ระบุ"
                            />
                          </b-form-group>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 col-md-6">
                          <div class="font-medium-4">
                            <span class="mr-2">Main image</span>
                            <span class="desc-title"
                              >(Format JPG, JPEG, PNG Max 2 Mb)</span
                            >
                          </div>
                          <image-upload
                            :removable="true"
                            :image-url="formData.mainImage.url"
                            @onUpload="onUploadMainImg"
                          />
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="font-medium-4">
                            <span class="mr-2">Sub image</span>
                            <span class="desc-title"
                              >(Format JPG, JPEG, PNG Max 2 Mb)</span
                            >
                          </div>
                          <image-upload
                            :removable="true"
                            :image-url="formData.subImage.url"
                            @onUpload="onUploadSubImg"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-9">
                  <div
                    class="row pl-1 mt-3 font-medium-5 font-weight-bolder text-black"
                  >
                    Redemptions
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <b-form-group
                        :label="'Point Used'"
                        label-for="campagin-name"
                        label-class="font-medium-5 required"
                      >
                        <b-input-group
                          class="input-group-merge"
                          label-class="font-medium-5 required"
                        >
                          <b-form-input
                            id="totalPoint"
                            v-model="formData.pointUsed"
                            @input="onNumberInput($event, 'totalPoint')"
                            placeholder="0"
                            required
                          />
                          <b-input-group-append is-text class="add-on-border">
                            <div>Point</div>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                      <b-form-group
                        :label="'Redeemable'"
                        label-for="campagin-name"
                        label-class="font-medium-5 required"
                      >
                        <b-input-group
                          class="input-group-merge"
                          label-class="font-medium-5 required"
                        >
                          <b-form-input
                            id="totalPoint"
                            v-model="formData.redeemable"
                            @input="onNumberInput($event, 'totalPoint')"
                            placeholder="0"
                            required
                          />
                          <b-input-group-append is-text class="add-on-border">
                            <div>Quantity</div>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                      <span
                        v-if="formData.redeemable <= 0"
                        class="text-color-warn"
                        >กรุณากรอกตัวเลขอย่างน้อย 1 ตัว
                      </span>
                    </div>
                  </div>

                  <b-row id="Valid-date">
                    <b-col cols="6">
                      <div class="d-flex">
                        <div class="p-0 p-relative mr-2">
                          <b-form-group
                            :label="'Valid From'"
                            label-for="campagin-name"
                            label-class="title-name font-medium-4 mt-2 required"
                          >
                            <flat-pickr
                              :id="'valid-from-date'"
                              v-model="formData.validFrom.date"
                              class="form-control bg-date"
                              :class="
                                formData.validFrom.date ? 'date-selected' : null
                              "
                              :config="flatpickrDateConfig"
                              placeholder="Select Date"
                              autocomplete="off"
                              required
                              @on-open="
                                flatpickrDateConfig.maxDate =
                                  formData.validThrough.date
                              "
                            />
                            <calendar-picker-icon
                              class="icon-calendar bypass"
                              :class="
                                formData.validFrom.date
                                  ? 'date-selected-icon'
                                  : null
                              "
                            />
                          </b-form-group>
                        </div>
                        <div class="p-0 p-relative">
                          <b-form-group
                            :label="'Time'"
                            label-for="campagin-name"
                            label-class="title-name font-medium-4 mt-2 required"
                          >
                            <flat-pickr
                              required
                              id="valid-from-time"
                              v-model="formData.validFrom.time"
                              class="form-control bg-date"
                              :class="
                                formData.validFrom.time ? 'date-selected' : null
                              "
                              :config="flatpickrTimeConfig"
                              :placeholder="'Select Time'"
                              autocomplete="off"
                              @on-change="
                                () => {
                                  if (
                                    formData.validFrom.date ==
                                      formData.validThrough.date &&
                                    formData.validFrom.time >
                                      formData.validThrough.time
                                  ) {
                                    formData.validThrough.time = null;
                                  }
                                }
                              "
                            />
                            <clock-picker-icon
                              class="icon-calendar date-picker-icon bypass"
                              :class="
                                formData.validFrom.time
                                  ? 'date-selected-icon'
                                  : null
                              "
                            />
                          </b-form-group>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="6">
                      <div class="d-flex">
                        <div class="p-0 p-relative mr-2">
                          <b-form-group
                            :label="'Valid Through'"
                            label-for="campagin-name"
                            label-class="title-name font-medium-4 mt-2 required"
                          >
                            <flat-pickr
                              required
                              :id="'valid-through-date'"
                              v-model="formData.validThrough.date"
                              class="form-control bg-date"
                              :class="
                                formData.validThrough.date
                                  ? 'date-selected'
                                  : null
                              "
                              :config="flatpickrDateConfig"
                              placeholder="Select Date"
                              autocomplete="off"
                              @on-open="
                                flatpickrDateConfig.minDate =
                                  formData.validFrom.date
                              "
                            />
                            <calendar-picker-icon
                              class="icon-calendar bypass"
                              :class="
                                formData.validThrough.date
                                  ? 'date-selected-icon'
                                  : null
                              "
                            />
                          </b-form-group>
                        </div>
                        <div class="p-0 p-relative">
                          <b-form-group
                            :label="'Time'"
                            label-for="campagin-name"
                            label-class="title-name font-medium-4 mt-2 required"
                          >
                            <flat-pickr
                              required
                              id="valid-from-time"
                              v-model="formData.validThrough.time"
                              class="form-control bg-date"
                              :class="
                                formData.validThrough.time
                                  ? 'date-selected'
                                  : null
                              "
                              :config="flatpickrTimeConfig"
                              :placeholder="'Select Time'"
                              autocomplete="off"
                              @on-open="
                                () => {
                                  if (
                                    formData.validFrom.date ==
                                    formData.validThrough.date
                                  ) {
                                    flatpickrTimeConfig.minTime =
                                      formData.validFrom.time;
                                  }
                                }
                              "
                            />
                            <clock-picker-icon
                              class="icon-calendar date-picker-icon bypass"
                              :class="
                                formData.validThrough.time
                                  ? 'date-selected-icon'
                                  : null
                              "
                            />
                          </b-form-group>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <div class="row align-self-stretch m-auto h-100 w-100">
                    <div class="col-12 pr-0 pl-0">
                      <div class="editor-wrp h-100 pb-1 mt-1">
                        <label class="font-medium-5 custom-tab-label"
                          >Term and Conditions</label
                        >
                        <b-tabs class="custom-tab flex-stretch h-100">
                          <b-tab
                            :title="'Thai'"
                            title-link-class="font-medium-5 tab1"
                            class=""
                            lazy
                          >
                            <custom-quill-editor
                              v-model="formData.ruleTh"
                              class="custom-quill-editor flex-stretch h-100"
                            />
                          </b-tab>
                          <b-tab
                            :title="'English'"
                            title-link-class="font-medium-5 tab2"
                            class=""
                            lazy
                          >
                            <custom-quill-editor
                              v-model="formData.ruleEn"
                              class="custom-quill-editor flex-stretch h-100"
                            />
                          </b-tab>
                        </b-tabs>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-9">
                  <div
                    class="row pl-1 mt-1 font-medium-5 font-weight-bolder text-black"
                  >
                    Issue Limit
                  </div>
                  <div class="mt-1">
                    <b-form-checkbox
                      fieldValue="true"
                      class="custom-control-success ml-4"
                      name="check-button"
                      switch
                      v-model="formData.issueLimit"
                    >
                    </b-form-checkbox>
                  </div>
                  <!-- v-if="formData.issueLimit" -->
                  <div v-if="formData.issueLimit">
                    <div
                      class="row pl-1 mt-1 font-medium-5 font-weight-bolder text-black"
                    >
                      Overall Limit
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="d-flex">
                          <div class="p-0 p-relative mr-2">
                            <b-form-group
                              :label="'Issue - Overall'"
                              label-for="campagin-name"
                              label-class="font-medium-5"
                            >
                              <b-input-group
                                class="input-group-merge"
                                label-class="font-medium-5"
                              >
                                <b-form-input
                                  id="totalPoint"
                                  type="number"
                                  v-model="formData.issueOverall"
                                  @input="onNumberInput($event, 'totalPoint')"
                                  placeholder="0"
                                />
                                <b-input-group-append
                                  is-text
                                  class="add-on-border"
                                >
                                  <div>Quantity</div>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                          </div>
                          <div class="p-0 p-relative">
                            <b-form-group
                              :label="'Issue - per Month'"
                              label-for="campagin-name"
                              label-class="font-medium-5"
                            >
                              <b-input-group
                                class="input-group-merge"
                                label-class="font-medium-5"
                              >
                                <b-form-input
                                  id="totalPoint"
                                  type="number"
                                  v-model="formData.issuePerMonth"
                                  @input="onNumberInput($event, 'totalPoint')"
                                  placeholder="0"
                                />
                                <b-input-group-append
                                  is-text
                                  class="add-on-border"
                                >
                                  <div>Qty/Month</div>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                            <span
                              v-if="
                                parseInt(formData.issuePerMonth) >
                                  parseInt(formData.issueOverall)
                              "
                              class="text-color-warn"
                              >มากกว่า Overall</span
                            >
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-md-3">
                        <b-form-group
                          :label="'Issue - per Day'"
                          label-for="campagin-name"
                          label-class="font-medium-5"
                        >
                          <b-input-group
                            class="input-group-merge"
                            label-class="font-medium-5"
                          >
                            <b-form-input
                              id="totalPoint"
                              type="number"
                              v-model="formData.issuePerDay"
                              @input="onNumberInput($event, 'totalPoint')"
                              placeholder="0"
                            />
                            <b-input-group-append is-text class="add-on-border">
                              <div>Qty/Day</div>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                        <span
                          v-if="
                            parseInt(formData.issuePerDay) >
                              parseInt(formData.issuePerMonth)
                          "
                          class="text-color-warn"
                          >มากกว่า Per Month</span
                        >
                      </div>
                    </div>

                    <div
                      class="row pl-1 mt-1 font-medium-5 font-weight-bolder text-black"
                    >
                      Customer Limit
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="d-flex">
                          <div class="p-0 p-relative mr-2">
                            <b-form-group
                              :label="'Issue - per Customer'"
                              label-for="campagin-name"
                              label-class="font-medium-5"
                            >
                              <b-input-group
                                class="input-group-merge"
                                label-class="font-medium-5"
                              >
                                <b-form-input
                                  id="totalPoint"
                                  type="number"
                                  v-model="formData.issuePerCustomer"
                                  @input="onNumberInput($event, 'totalPoint')"
                                  placeholder="0"
                                />
                                <b-input-group-append
                                  is-text
                                  class="add-on-border"
                                >
                                  <div>Person</div>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                            <span
                              v-if="
                                parseInt(formData.issuePerCustomer) >
                                  parseInt(formData.issueOverall)
                              "
                              class="text-color-warn"
                              >มากกว่า Overall</span
                            >
                          </div>
                          <div class="p-0 p-relative">
                            <b-form-group
                              :label="'Issue - per Customer / Month'"
                              label-for="campagin-name"
                              label-class="font-medium-5"
                            >
                              <b-input-group
                                class="input-group-merge"
                                label-class="font-medium-5"
                              >
                                <b-form-input
                                  id="totalPoint"
                                  type="number"
                                  v-model="formData.issuePerCustomerMonth"
                                  @input="onNumberInput($event, 'totalPoint')"
                                  placeholder="0"
                                />
                                <b-input-group-append
                                  is-text
                                  class="add-on-border"
                                >
                                  <div>Person/Month</div>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                            <span
                              v-if="
                                parseInt(formData.issuePerCustomerMonth) >
                                  parseInt(formData.issuePerCustomer) ||
                                  parseInt(formData.issuePerCustomerMonth) >
                                    parseInt(formData.issuePerMonth)
                              "
                              class="text-color-warn"
                              >มากกว่า Per Customer หรือ Per Month</span
                            >
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-md-3">
                        <b-form-group
                          :label="'Issue - per Customer / Day'"
                          label-for="campagin-name"
                          label-class="font-medium-5"
                        >
                          <b-input-group
                            class="input-group-merge"
                            label-class="font-medium-5"
                          >
                            <b-form-input
                              type="number"
                              id="totalPoint"
                              v-model="formData.issuePerCustomerDay"
                              @input="onNumberInput($event, 'totalPoint')"
                              placeholder="0"
                            />
                            <b-input-group-append is-text class="add-on-border">
                              <div>Person/Day</div>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                        <span
                          v-if="
                            parseInt(formData.issuePerCustomerDay) >
                              parseInt(formData.issuePerCustomerMonth) ||
                              parseInt(formData.issuePerCustomerDay) >
                                parseInt(formData.issuePerDay)
                          "
                          class="text-color-warn"
                          >มากกว่า Per Customer / Month หรือ Per Day</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import CalendarPickerIcon from "@/@core/components/svg/common/CalendarPicker2.vue";
import ClockPickerIcon from "@/@core/components/svg/common/ClockPicker.vue";
import flatPickr from "vue-flatpickr-component";
import useCampaignInfo from "./hooks/useCampaignInfo";
import ImageUpload from "@/views/components/image-upload/ImageUpload.vue";

export default {
  components: { CalendarPickerIcon, ClockPickerIcon, flatPickr, ImageUpload },

  setup() {
    const {
      formData,
      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      onSubmitForm,
      onUploadMainImg,
      onUploadSubImg,
      onNumberInput,
      isEdit,
      checkInput,
    } = useCampaignInfo();

    return {
      formData,
      CalendarPickerIcon,
      ClockPickerIcon,
      flatPickr,
      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      onSubmitForm,
      onUploadMainImg,
      onUploadSubImg,
      onNumberInput,
      isEdit,
      checkInput,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style>
#campaign-info-lucky .editor-wrp {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
}

#campaign-info-lucky .custom-tab .tab-content,
#privilege-info .custom-tab .tab-content .tab-pane {
  /* height: 100%; */
  position: relative;
  z-index: 99;
}

#campaign-info-lucky .nav-tabs {
  margin-bottom: -0.8rem !important;
}

#campaign-info-lucky .custom-tab .nav-tabs .nav-link {
  position: relative;
  background: #ffffff;
  border: 1px solid #e2e2e2;
  /* border-radius: 1rem 1rem 0 0; */
  padding: 0.4rem 2rem;
  margin: 0px !important;
  min-width: 150px;
  min-height: 60px;
}

#campaign-info-lucky .custom-tab .nav-tabs .nav-link.tab1 {
  border-radius: 1rem 0 0 0 !important;
}

#campaign-info-lucky .custom-tab .nav-tabs .nav-link.tab2 {
  border-radius: 0 1rem 0 0 !important;
}

#campaign-info-lucky .custom-tab .nav-tabs .nav-link.active {
  background-color: #e2e2e2 !important;
  color: #000 !important;
  /* border-bottom: 10px double white; */
}

#campaign-info-lucky .text-color-warn {
  color: #ea5355;
}
</style>

<style scoped>
@import "~@/assets/css/pages/data-management.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";

.border-b {
  padding-bottom: 30px;
  border-bottom: 1px solid #ececec;
}

#Valid-date .icon-calendar {
  left: 11px;
  top: calc(68% - 10px);
  fill: #6c8baf !important;
}

#Valid-date .form-control {
  padding: 0.438rem 1rem 0.438rem 3rem;
}

#Valid-date .date-picker-icon {
  top: 68% !important;
}

#campaign-info-lucky .input-group-text {
  color: #a2a2a2;
}

#campaign-info-lucky .desc-title {
  color: #cecece;
}

#campaign-info-lucky .bg-date::placeholder {
  color: #728aac !important;
}

#campaign-info-lucky .bg-date {
  border: 1px solid #6c8baf !important;
  color: #728aac !important;
}

#campaign-info-lucky .bg-date:hover {
  background-color: #6c8baf !important;
  color: #eee !important;
}

#campaign-info-lucky .bg-date:hover ~ .hover-day {
  background-color: #6c8baf !important;
  color: #eee !important;
}

#campaign-info-lucky .bg-date:hover ~ .icon-calendar {
  fill: #eee !important;
}

#campaign-info-lucky .bg-date:hover::placeholder {
  color: #eee !important;
}

#campaign-info-lucky .bg-date:hover ~ .date-picker-icon {
  fill: #eee !important;
}
</style>
